import { useSession } from 'next-auth/react';
import { useCallback } from 'react';

export const usePermissions = () => {
  const { data: session } = useSession();
  const user = session?.user;

  const hasPermission = useCallback(
    (permissionName: string) => {
      return user?.permissions?.some((permission: any) => permission.name === permissionName);
    },
    [user],
  );

  return { hasPermission };
};
